import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAcStats } from '../../providers/AcStats';
import { generatePrevNMonths, numberShorten } from '../../helpers/dateHelpers';
import './AcStats.scss';
import { months } from '../../constants/dates';

export default function AcStats() {
    const { t } = useTranslation();
    const AcStatsContext = useAcStats();
    const [acStats, setAcStats] = useState<any>([]);
    const sortOrder = ['ac.flight.miles.monthly','ac.flight.hrs.monthly','ac.flight.pax.flown','ac.flight.miles.yearly'];
    const previousMonth = months[generatePrevNMonths()[0].monthNumber - 1];
    const yearForPreviousMonth = generatePrevNMonths()[0].year;

    const sortForDisplay = (arrayData) => {
        let ordering = {}
        for (var i=0; i<sortOrder.length; i++) {
            ordering[sortOrder[i]] = i;
        }
        arrayData.sort( function(a, b) {
            return (ordering[a.module] - ordering[b.module]);
        });
        setAcStats([...arrayData]);
    }

    useEffect(() => {
        if(!AcStatsContext?.AcStatsData?.flightstats?.length) {
          return;
        }
        setAcStats(AcStatsContext?.AcStatsData?.flightstats);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [AcStatsContext?.AcStatsData, AcStatsContext?.AcStatsData?.flightstats?.length]);


    useEffect( () => {
        if(!acStats || !acStats.length) {
            return
        }
        setAcStats({...AcStatsContext?.AcStatsData?.flightstats});
        sortForDisplay(acStats); 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [acStats.length]);

    
   let flightstatsModuleMapper = new Map();
   flightstatsModuleMapper.set('ac.flight.miles.monthly', `${t('home.in-air')} ${previousMonth} ${yearForPreviousMonth}`)
   flightstatsModuleMapper.set('ac.flight.hrs.monthly', `${t('home.hrs-flown')} ${previousMonth} ${yearForPreviousMonth}`)
   flightstatsModuleMapper.set('ac.flight.pax.flown', `${t('home.passengers-flown')} ${previousMonth} ${yearForPreviousMonth}`)
   flightstatsModuleMapper.set('ac.flight.miles.yearly', `${t('home.in-air')} ${yearForPreviousMonth}`)

   

    return (
        <Grid container spacing={1} className='bg-white stats'>
         
            { acStats.map( (item, index) => {
                return (
                    <Grid item xs={6} key={index}>
                        <div className="bg-light-blue">
                            <span className='card-subtitle'>{flightstatsModuleMapper.get(item.module)} </span>
                            <span className='card-value'>{numberShorten(item.value.data)}</span>
                        </div>
                    </Grid>
                )
            })}
                    
        </Grid>
        
    );
}
